"use client";

import '@/style/css/Profil.css';
import { useContext } from 'react';
import TokenContext from '@/context/TokenProvider';
import MessageContext from '@/context/MessageProvider';
import useSWR from "swr";
import { Star, StarOutline } from "@mui/icons-material";
import { Button, SxProps, Theme, Typography } from "@mui/material";

export interface PenandaKoleksiButtonProps {
  id: string;
  sx?: SxProps<Theme> | null;
}

type BookmarkResponse = {
  bookmark: boolean;
}

const PenandaKoleksiButton = ({ id, sx }: PenandaKoleksiButtonProps) => {
  const { accessToken, authenticatedFetcher } = useContext(TokenContext)!;

  const { message, setMessage } = useContext(MessageContext)!;

  const {
    data: penandaKoleksi,
    isLoading: penandaKoleksiIsLoading,
    mutate
  } = useSWR<BookmarkResponse>(`${process.env.NEXT_PUBLIC_API_URL}/v2/koleksi/${id}/bookmark`, authenticatedFetcher);

  const simpanPenandaKoleksi = async () => {
    if (!accessToken) return;

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/v2/koleksi/${id}/bookmark`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    if (response.ok) {
      setMessage({ isOpen: true, content: 'Koleksi berhasil disimpan.' });
    }

    mutate({ bookmark: true });
  };

  const hapusPenandaKoleksi = async () => {

    if (!accessToken) return;

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/v2/koleksi/${id}/bookmark`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    if (response.ok) {
      setMessage({ isOpen: true, content: 'Tanda koleksi berhasil dihapus.' });
    }

    mutate({ bookmark: false });
  };

  const handleClick = () => {
    if (penandaKoleksi?.bookmark) {
      hapusPenandaKoleksi();
    } else {
      simpanPenandaKoleksi();
    }
  };

  return accessToken ? <Button
    fullWidth
    size="large"
    variant="contained" sx={{
    ...sx
  }}
    startIcon={penandaKoleksi?.bookmark ? <Star/> : <StarOutline/>}
    loading={penandaKoleksiIsLoading}
    onClick={handleClick}
    loadingPosition={'start'}
    disabled={penandaKoleksiIsLoading}
  >
    <Typography sx={{
      marginLeft: 'auto',
      marginRight: 'auto'
    }}>
      Tandai Buku
    </Typography>
  </Button> : null
};

export default PenandaKoleksiButton;
